
import Cookies from "cookies-js"

Cookies.defaults.path     = "/"
Cookies.defaults.secure   = false
// 1day
Cookies.defaults.expires  = (24 * 60 * 60)

export default Cookies
